import React, { Component, Fragment } from "react";
import { CSSTransition } from "react-transition-group";
import { Row } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import compose from "compose-function";
import { translate } from "react-multi-lang";

class LoaderComponent extends Component {
  constructor(props) {
    super(props);
    this.loaderNodeRef = React.createRef();
  }

  render() {
    return (
      <Fragment>
        <CSSTransition
          in={this.props.loading}
          appear={true}
          timeout={500}
          classNames="TabsAnimation"
          nodeRef={this.loaderNodeRef}
          unmountOnExit
        >
          <div ref={this.loaderNodeRef}>
            <Row>
              <div className="w-100 loader-s d-flex justify-content-center align-items-center">
                <div className="text-center">
                  <img src={require("../../../assets/img/svg/Argos.svg")} />
                </div>
                <div className="browser-screen-loading-content">
                  <div className="loading-dots dark-gray">
                    <i />
                    <i />
                    <i />
                    <i />
                  </div>
                </div>
              </div>
            </Row>
          </div>
        </CSSTransition>
      </Fragment>
    );
  }
}

export default compose(
  translate,
  withRouter,
  connect()
)(LoaderComponent);
